module.exports = __webpack_public_path__ + "static/media/markdown-previewer-preview.b66e64d8.png";